import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from './Callback.style';

const Callback = () => {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(isAuthenticated ? '/curve-list' : '/login', { replace: true });
  }, [isAuthenticated, navigate]);

  return <Loading />;
};

export default Callback;
